import {
  fetchLinkedDevices,
  fetchUnlinkedDevices,
  fetchLinkedEmissionPoints,
  fetchUnlinkedEmissionPoints,
  assignDevices,
  assignEmissionPoints
} from "../services/userService";

export default function useUserResources(username) {
  const loadAllResources = async () => {
    const [
      assignedDevices, unassignedDevices,
      assignedEPs, unassignedEPs
    ] = await Promise.all([
      fetchLinkedDevices(username),
      fetchUnlinkedDevices(username),
      fetchLinkedEmissionPoints(username),
      fetchUnlinkedEmissionPoints(username),
    ]);

    const devices = [...assignedDevices, ...unassignedDevices].map(d => ({ key: d.id.toString(), title: d.name }));
    const emissionPoints = [...assignedEPs, ...unassignedEPs].map(p => ({ key: p.id.toString(), title: p.name }));

    return {
      devices,
      deviceTargetKeys: assignedDevices.map(d => d.id.toString()),
      emissionPoints,
      emissionTargetKeys: assignedEPs.map(p => p.id.toString()),
    };
  };

  const saveAssignments = async (deviceIds, epIds) => {
    await Promise.all([
      assignDevices(username, deviceIds),
      assignEmissionPoints(username, epIds),
    ]);
  };

  return {
    loadAllResources,
    saveAssignments
  };
}
